export const search = {
   uri: "/data/work/searchArtists.php",
} as const;
